import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

export const SignOutButton = () => {
    const { instance } = useMsal();
    
    const handleLogout = (logoutType) => {
        if (logoutType === "redirect") {
           instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
            localStorage.clear();
            caches.delete();
        }
    }

    return (
        <Button variant="text" sx={{color: '#ffffff'}} aria-label="Sign Out" onClick={() => handleLogout("redirect")}><LogoutOutlinedIcon  /></Button>
    );
}